module.exports = __webpack_public_path__ + "images/green.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/green.png
// module id = 1457
// module chunks = 0